import { getNonce } from './nonce.utils';

/**
 * Dynamically creates and executes an inline script with CSP nonce support.
 * The script is automatically removed from the DOM after execution.
 *
 * @param options - Configuration object
 * @param options.scriptSrc - The inline script text to execute
 */
export const executeDynamicInlineScript = ({
  scriptSrc,
}: {
  scriptSrc: string;
}): void => {
  const nonce = getNonce();
  if (!nonce)
    throw new Error('CSP nonce is required for dynamic script execution');
  const script = document.createElement('script');
  script.setAttribute('nonce', nonce);
  script.textContent = scriptSrc;
  document.head.appendChild(script);
  script.remove();
};
